import { Modal, NotificationBanner } from 'BreetComponents';
import { manuallyTriggeredModals, modalContent } from 'BreetConfig';
import { useVersionCheck } from 'BreetHooks';
import { selectModals, useAppSelector } from 'BreetRedux';
import { type PropsWithChildren, useCallback, useEffect, useState } from 'react';

export const BaseLayout = ({ children }: PropsWithChildren) => {
	const modals = useAppSelector(selectModals);

	const [showNotification, setShowNotification] = useState(false);

	const reloadPage = useCallback(() => {
		window.location.reload();
	}, []);

	useVersionCheck({
		storage: 'session',
		versionCheckType: 'route-change',
		throttleMs: 60,
		timeUnit: 'seconds',
		onNewVersion(versionCheckAction) {
			if (versionCheckAction === 'reload-page') {
				reloadPage();
			}
			if (versionCheckAction === 'prompt-user') {
				setShowNotification(true);
			}
		},
	});

	useEffect(() => {
		const vitePreloadError = sessionStorage.getItem('vitePreloadError');
		if (vitePreloadError) {
			sessionStorage.removeItem('vitePreloadError');
			sessionStorage.removeItem('vitePreloadErrorCount');
		}
	}, []);

	return (
		<>
			{showNotification && (
				<NotificationBanner
					type='sticky'
					message='A new app version is available. Reload to update.'
					buttonTitle='Reload'
					onButtonClick={reloadPage}
					onCancel={reloadPage}
				/>
			)}
			<div className='bt_layout_base'>
				{children}
				{modals
					.filter((modal) => !manuallyTriggeredModals.includes(modal.id))
					.map((modal) => (
						<Modal
							key={modal.id}
							modalId={modal.id}
							{...modal}
						>
							{modalContent[modal.id]}
						</Modal>
					))}
			</div>
		</>
	);
};
